<div [id]="chartId" class="w-full h-full flex items-center justify-center">
</div>